<template>
    <div class="d-flex flex-row flex-nowrap gap-3">
        <GridButton
            text=""
            :row="row"
            icon="fa-magnifying-glass"
            :onClick="onClick"
            :title="$tm('participant.search')"
        ></GridButton>
        <div class="flex-fill w-100">{{ value }}</div>
    </div>
</template>
<script lang="ts" setup>
import { GridButton } from '@/components';
import { $tm } from '@/locize';
import { Participant, type RelayTeamContestant } from '@/objects/generated';
import { OpenParticipantSearchModal } from '@/utilities';

const props = defineProps<{
    value: string | null;

    row: RelayTeamContestant;
}>();

const emit = defineEmits<{
    (e: 'participantSelected', participant: Participant | null, row: RelayTeamContestant): void;
}>();

const onClick = () => {
    // We open the participant search dialog
    OpenParticipantSearchModal((participant: Participant | null) => {
        emit('participantSelected', participant, props.row);
    });
};
</script>
